import { formatIntlMessage as formatIntlMessageCommon, useIntlModule as useIntlModuleCommon } from '@enterprise/common';

export const useIntlModule = useIntlModuleCommon;

export const formatIntlMessage = formatIntlMessageCommon;
